// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"7ccde09b9eb70b9b3753","293":"142ad36c37b59410d726","518":"74d9a57898878b3dec19","779":"d388a8d083c4cab1b50c"}[chunkId] + ".js";
};